<script lang="ts" setup>
const { public: config } = useRuntimeConfig()

const { data: response } = await useGraphqlQuery('layout', {
  locale: config.strapiLocale,
}, useGraphqlDefaultClient())

const header = ref<HTMLElement | null>(null)
const headerHeight = ref('auto')

useResizeObserver(header, (entries) => {
  const entry = entries[0]

  if (entry?.contentRect) {
    const { height } = entry.contentRect
    headerHeight.value = `${height}px`
  }
})
</script>

<template>
  <header
    ref="header"
    class="checkout-header"
  >
    <Html
      v-if="headerHeight !== 'auto'"
      :style="`--header-height: ${headerHeight};`"
    />

    <div class="checkout-header__usps">
      <AppUsps
        v-if="response?.headerUsps?.[0]?.Usp?.length"
        class="checkout_header__container"
        :usps="response.headerUsps[0].Usp"
        horizontal
      />
    </div>
    <div class="checkout-header__layout">
      <AppLogo
        data-testid="logo"
        class="checkout-header__logo"
      />

      <CartMiniCart class="checkout-header__mini-cart" />

      <CheckoutSteps class="checkout-header__steps" />
    </div>
  </header>
</template>

<style>
@import url("~layers/app/components/Checkout/Header.css");
</style>
